import { getQRCode } from '@/utils/common.js';

export default {
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
    getQRCode
  }
};
